import { FormBuilder, Modal } from "shared/components";
import { IEventBlock } from "Bands/types";
import { copy } from "shared/assets";
import { IAPIState, IFieldType } from "shared/types";
import { useDispatch, useSelector } from "react-redux";
import { dataMetaSelector } from "Bands/state";
import { useEffect } from "react";
import { useClearActionMetaOnUnMount } from "Bands/utils";

interface EditEventBlockTitleModalProps {
  block: IEventBlock;
  handleClose: () => void;
}

export const EditEventBlockTitleModal = ({
  block: { id, icon, title, editTitleAction = "", handleEditTitle = () => {} },
  handleClose,
}: EditEventBlockTitleModalProps) => {
  const dispatch = useDispatch();
  const { api: apiMeta } = useSelector(dataMetaSelector(editTitleAction));

  useClearActionMetaOnUnMount(editTitleAction);

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      handleClose();
    }
  }, [apiMeta, handleClose]);

  const onSubmit = ({ title }: { title: string }) => {
    dispatch(handleEditTitle({ title, id }));
  };

  return (
    <Modal
      icon={icon}
      title={`${copy.eventBlock.editTitle.title} ${title}`}
      handleClose={handleClose}
    >
      <FormBuilder
        onSubmit={onSubmit}
        fields={[
          {
            name: "title",
            label: "Title",
            type: IFieldType.text,
            validation: {
              required: copy.errors.required,
            },
          },
        ]}
        buttons={{
          primary: { "data-testid": "submit_edit_title" },
          secondary: { onClick: handleClose },
        }}
        isSubmitting={apiMeta?.status === IAPIState.pending}
        apiErrorMessage={!!apiMeta?.error}
        apiError={apiMeta?.error}
        defaultValues={{ title }}
        submitMode="isDirty"
      />
    </Modal>
  );
};
